export class Carousels {
    init()
    {
        var carouselThumbs2 = $('.gallery-thumbs .owl-carousel, .article-list__slider .owl-carousel, .slider .owl-carousel, .gallery-category--logos .owl-carousel'),
            carouselThumbs = $('.slider.slider-investitions .owl-carousel '),
            carouselZoom = $('.gallery-category--zoom-slider .owl-carousel '),
            pluginFlag = carouselThumbs.length || carouselZoom.length;

        if (pluginFlag)
            if (carouselThumbs)
                this.carouselThumbs(carouselThumbs);
            if (carouselThumbs2)
                this.carouselThumbs2(carouselThumbs2);
        if (carouselZoom)
            this.carouselZoom(carouselZoom);
        
        $('.swiper-container.gallery-top').each(function(index){
            var autoplay = false;
            if($(this).data('autoplay') && $(this).data('autoplay') === true){
                autoplay = {
                    delay: ($(this).data('autoplayDelay') ? $(this).data('autoplayDelay') : 1500),
                    disableOnInteraction: true
                };
            }

            var galleryTop = new Swiper($(this), {
                slidesPerView: $(this).data('items'),
                effect: 'flip',
                grabCursor: true,
                loopedSlides: $(this).find('.swiper-slide').length,
                loop: ($(this).data('loop') ? $(this).data('loop') : false),
                centeredSlides: ($(this).data('slideCenter') || ($(this).data('loop') === true && $(this).siblings('.swiper-container.gallery-thumbs').length > 0) ? true : false),
                spaceBetween: 30,
                pagination: {
                    el: $(this).children('.swiper-pagination')
                },
                autoplay: autoplay,
                navigation: {
                    nextEl: $(this).children('.swiper-button-next'),
                    prevEl: $(this).children('.swiper-button-prev'),
                },
                breakpoints: {
                    1200: {
                      slidesPerView: ($(this).data('itemsXl') ? $(this).data('itemsXl') : $(this).data('items')),
                      spaceBetween: 40,
                    },
                    992: {
                      slidesPerView: ($(this).data('itemsLg') ? $(this).data('itemsLg') : $(this).data('items')),
                      spaceBetween: 30,
                    },
                    768: {
                      slidesPerView: ($(this).data('itemsMd') ? $(this).data('itemsMd') : $(this).data('items')),
                      spaceBetween: 20,
                    },
                    576: {
                      slidesPerView: ($(this).data('itemsSm') ? $(this).data('itemsSm') : $(this).data('items')),
                      spaceBetween: 10,
                    }
                  }
            });

            var galleryThumbs = new Swiper($(this).siblings('.swiper-container.gallery-thumbs'), {
                spaceBetween: 10,
                centeredSlides: true,
                slidesPerView: 'auto',
                touchRatio: 0.2,
                slideToClickedSlide: true,
                loopedSlides: $(this).find('.swiper-slide').length,
                loop: ($(this).data('loop') ? $(this).data('loop') : false),
              });

            if(galleryThumbs.controller && galleryThumbs.controller !== "undefined"){
                galleryTop.controller.control = galleryThumbs;
                galleryThumbs.controller.control = galleryTop;
            }
       });
    }

    carouselThumbs2(carousel)
    {
        carousel.owlCarousel({
            items: 8,
            loop: true,
            margin: 20,
            nav: false,
            navText: ['<i class="fa fa-arrow-circle-o-left"></i>', '<i class="fa fa-arrow-circle-o-right"></i>'],
            dots: false,
            thumbs: true,
            autoplay: typeof carousel.data('autoplay') !== 'undefined' ? carousel.data('autoplay') : false,
            autoplayTimeout: 2000,
            thumbsPrerendered: true,
            responsive: {
                0: {
                    items: 3,
                    autoWidth: true
                },
                320: {
                    items: 3
                },
                641: {
                    items: 4,
                    autoWidth: true,
                    center: false
                },
                1024: {
                    items: 6,
                    center: true,
                    autoWidth: true
                },
                1350: {
                    items: 8,
                    center: true,
                    autoWidth: true
                }
            },
            onChanged: function (e)
            {
                var itemsLength = this._items.length;

                var $slider = this.$element.closest('.slider'),
                    $slides = $slider.find('.owl-carousel .owl-item:not(.cloned)'),
                    $thumbsContainer = $slider.find('.slider-thumbs'),
                    $thumbsList = $slider.find('.owl-thumbs');

                var thumbWidth = $thumbsList.find('.owl-thumb-item').outerWidth(true),
                    thumbsListWidth = thumbWidth * itemsLength,
                    thumbsContainerWidth = $thumbsContainer.width();

                var thumbsOuterWidth = thumbsListWidth - thumbsContainerWidth,
                    thumbsPositionPart = thumbsOuterWidth / itemsLength;

                var currentPosition = $thumbsList.find('.owl-thumb-item.active').index(),
                    currentSlide = $slides.eq( currentPosition );

                var firstMarginLeft = parseInt( $thumbsList.find('.owl-thumb-item').first().css('margin-left') ),
                    lastMarginRight = parseInt( $thumbsList.find('.owl-thumb-item').last().css('margin-right') );

                var offset = currentPosition === 0
                                    ? -firstMarginLeft
                                    : (currentPosition === itemsLength - 1
                                        ? ( thumbsContainerWidth - thumbsListWidth + lastMarginRight )
                                        : ((-currentPosition + 1) * thumbsPositionPart - firstMarginLeft)
                                    );


                if( thumbsOuterWidth <= 0 )
                {
                    $thumbsList.css({
                        '-webkit-transform': 'translateX(' + -firstMarginLeft + 'px)',
                        '-mox-transform': 'translateX(' + -firstMarginLeft + 'px)',
                        'transform': 'translateX(' + -firstMarginLeft + 'px)'
                    });
                }
                else if( thumbsOuterWidth > 0 )
                {
                    $thumbsList.css({
                        '-webkit-transform': 'translateX(' + offset + 'px)',
                        '-mox-transform': 'translateX(' + offset + 'px)',
                        'transform': 'translateX(' + offset + 'px)'
                    });
                }

                setTimeout(function () {
                    currentSlide.addClass('active');
                });
            }
        });
    }
    carouselThumbs(carousel)
    {
        carousel.owlCarousel({
            items: 1,
            loop: true,
            margin: 20,
            nav: false,
            navText: ['<i class="fa fa-arrow-circle-o-left"></i>', '<i class="fa fa-arrow-circle-o-right"></i>'],
            dots: false,
            thumbs: true,
            autoplay: false,
//            autoplayTimeout: 2000,
            thumbsPrerendered: true,
            responsive: {
                0: {
                    items: 1,
//                    autoWidth: true
                },
                320: {
                    items: 1
                },
                641: {
                    items: 1,
//                    autoWidth: true,
                    center: false
                },
                1024: {
                    items: 1,
                    center: true,
//                    autoWidth: true
                },
                1350: {
                    items: 1,
                    center: true,
//                    autoWidth: true
                }
            },
            onChanged: function (e)
            {
                var itemsLength = this._items.length;

                var $slider = this.$element.closest('.slider'),
                    $slides = $slider.find('.owl-carousel .owl-item:not(.cloned)'),
                    $thumbsContainer = $slider.find('.slider-thumbs'),
                    $thumbsList = $slider.find('.owl-thumbs');

                var thumbWidth = $thumbsList.find('.owl-thumb-item').outerWidth(true),
                    thumbsListWidth = thumbWidth * itemsLength,
                    thumbsContainerWidth = $thumbsContainer.width();

                var thumbsOuterWidth = thumbsListWidth - thumbsContainerWidth,
                    thumbsPositionPart = thumbsOuterWidth / itemsLength;

                var currentPosition = $thumbsList.find('.owl-thumb-item.active').index(),
                    currentSlide = $slides.eq( currentPosition );

                var firstMarginLeft = parseInt( $thumbsList.find('.owl-thumb-item').first().css('margin-left') ),
                    lastMarginRight = parseInt( $thumbsList.find('.owl-thumb-item').last().css('margin-right') );

                var offset = currentPosition === 0
                                    ? -firstMarginLeft
                                    : (currentPosition === itemsLength - 1
                                        ? ( thumbsContainerWidth - thumbsListWidth + lastMarginRight )
                                        : ((-currentPosition + 1) * thumbsPositionPart - firstMarginLeft)
                                    );


                if( thumbsOuterWidth <= 0 )
                {
                    $thumbsList.css({
                        '-webkit-transform': 'translateX(' + -firstMarginLeft + 'px)',
                        '-mox-transform': 'translateX(' + -firstMarginLeft + 'px)',
                        'transform': 'translateX(' + -firstMarginLeft + 'px)'
                    });
                }
                else if( thumbsOuterWidth > 0 )
                {
                    $thumbsList.css({
                        '-webkit-transform': 'translateX(' + offset + 'px)',
                        '-mox-transform': 'translateX(' + offset + 'px)',
                        'transform': 'translateX(' + offset + 'px)'
                    });
                }

                setTimeout(function () {
                    currentSlide.addClass('active');
                });
            }
        });
    }

    carouselZoom(carousel)
    {
        carousel.owlCarousel({
            stagePadding: 0,
            loop: false,
            autoWidth: true,
            center: true,
            margin: 0,
            responsive: {
                0: {
                    items: 3,
                    autoWidth: true
                },
                320: {
                    items: 3
                },
                641: {
                    items: 4,
                    autoWidth: true,
                    center: false
                },
                1024: {
                    items: 6,
                    center: true,
                    autoWidth: true
                },
                1350: {
                    items: 8,
                    center: true,
                    autoWidth: true
                }
            }
        });


        carousel.find('.owl-item').on('click', function ()
        {
            var $this = $(this),
                    index = $this.index(),
                    itemsLength = $this.siblings('.owl-item').length,
                    itemsHandler = $this.closest('.owl-stage-outer'),
                    activeItems = $this.closest('.gallery-category--zoom-slider').find('.active');

            if ($this.hasClass('zoomed'))
            {
                $this.removeClass('zoomed');
            } else if (($this.prev().hasClass('active') && $this.next().hasClass('active')) || (!$this.prev().hasClass('active') && !$this.next().hasClass('active')))
            {
                $('.zoomed').removeClass('zoomed');
                $this.addClass('zoomed');
            } else if ($this.prev().hasClass('active') && !$this.next().hasClass('active'))
            {
                carousel.trigger('next.owl.carousel', [500]);
                $('.zoomed').removeClass('zoomed');
                $this.addClass('zoomed');
            } else if (!$this.prev().hasClass('active') && $this.next().hasClass('active'))
            {
                carousel.trigger('prev.owl.carousel', [500]);
                $('.zoomed').removeClass('zoomed');
                $this.addClass('zoomed');
            }
        });
    }
}